export enum SettingsTabs {
  INFORMATION = 'information',
  PREFERENCES = 'preferences',
  INTEGRATIONS = 'integrations',
  DATA = 'data',
  PAGES = 'pages',
}

export type TabList = {
  id: SettingsTabs, label: string,
}